import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { motion } from "framer-motion";
import { ReactNode } from "react";

interface ChartSectionProps {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  description: string;
  children: ReactNode;
}

export const ChartSection = ({
  icon: Icon,
  iconColor,
  title,
  description,
  children
}: ChartSectionProps) => {
  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon className={`h-6 w-6 ${iconColor}`} />
        <div>
          <h3 className="font-semibold">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      <div className="h-[400px] w-full">
        {children}
      </div>
    </Card>
  );
};